import { Sparkles, ArrowRight } from "lucide-react";
import { bestTextOn } from "@/lib/contrast";

const HEX = /^#(?:[0-9a-fA-F]{3}|[0-9a-fA-F]{6})$/;

// Live preview of a themed nav, button and careers hero so admins see the brand before saving.
export function BrandPreview({ primary = "#10B981", name = "HireStream", logo = null }) {
  const c = HEX.test(primary) ? primary : "#10B981";
  const onC = bestTextOn(c);
  const label = name || "HireStream";
  return (
    <div className="space-y-2" data-testid="brand-preview">
      {/* App chrome mock */}
      <div className="rounded-lg border border-border overflow-hidden">
        <div className="flex items-center justify-between px-3 py-2" style={{ background: `${c}14`, borderBottom: `1px solid ${c}33` }}>
          <div className="flex items-center gap-2 min-w-0">
            {logo ? <img src={logo} alt="" className="h-5 w-5 rounded object-contain shrink-0" /> : <span className="h-5 w-5 rounded shrink-0" style={{ background: c }} />}
            <span className="text-sm font-semibold truncate" style={{ color: c }}>{label}</span>
          </div>
          <span className="text-[10px] px-2 py-0.5 rounded-full shrink-0" style={{ background: `${c}22`, color: c }}>Preview</span>
        </div>
        <div className="flex items-center gap-2 px-3 py-3 bg-card">
          <button type="button" className="text-xs font-semibold px-3 py-1.5 rounded-md" style={{ background: c, color: onC }}>Primary button</button>
          <span className="inline-flex items-center gap-1 text-[11px] px-2 py-1 rounded-full border" style={{ color: c, borderColor: `${c}55`, background: `${c}10` }}><Sparkles className="h-3 w-3" /> Accent</span>
        </div>
      </div>

      {/* Careers hero mock — logo + brand swap in instantly */}
      <div className="rounded-lg border border-border overflow-hidden" data-testid="brand-hero-mock">
        <div className="relative px-4 py-5" style={{ background: `linear-gradient(135deg, ${c}26 0%, ${c}0a 60%, transparent 100%)` }}>
          <div className="flex items-center gap-2 mb-3">
            {logo ? <img src={logo} alt="" className="h-6 w-6 rounded object-contain" data-testid="brand-hero-logo" /> : <span className="h-6 w-6 rounded" style={{ background: c }} />}
            <span className="text-xs font-semibold" style={{ color: c }}>{label} Careers</span>
          </div>
          <div className="text-[15px] font-semibold leading-snug text-foreground">Build what's next with {label}</div>
          <p className="text-[11px] text-muted-foreground mt-1 mb-3 max-w-[90%]">Explore open roles and join a team that ships. Your application is reviewed by a real person.</p>
          <span className="inline-flex items-center gap-1.5 text-xs font-semibold px-3 py-1.5 rounded-md" style={{ background: c, color: onC }}>View open roles <ArrowRight className="h-3.5 w-3.5" /></span>
        </div>
      </div>
    </div>
  );
}
